var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Inset } from 'syf-component-library/ui/spacing';
import { generateUUID } from 'syf-js-utilities';
import useWindowSize from 'syf-component-library/ui/customHooks/useWindowWidth';
import { BodyContent, HeaderContainer, Image, ImageContainer, InlineBodyContent, InlineContentContainer, InlineContentTitle, InlineHeaderContainer, InlineImageContainer, Title } from './subcomponents';
import DisputesImage from '../DisputesImage';
var BannerWithText = function (_a) {
    var bannerImage = _a.bannerImage, altText = _a.altText, content = _a.content, paragraphs = _a.paragraphs, inlineDesign = _a.inlineDesign, assetsURL = _a.assetsURL, props = __rest(_a, ["bannerImage", "altText", "content", "paragraphs", "inlineDesign", "assetsURL"]);
    var isLessThanTablet = useWindowSize().isLessThanTablet;
    var imageSize = isLessThanTablet ? 'xxsmall' : 'xsmall';
    return inlineDesign ? (_jsxs(InlineHeaderContainer, __assign({}, props, { children: [_jsx(InlineImageContainer, { children: _jsx(DisputesImage, { assetsHost: assetsURL, imageName: bannerImage, size: imageSize }) }), _jsxs(InlineContentContainer, { children: [_jsx(InlineContentTitle, { children: content }), paragraphs === null || paragraphs === void 0 ? void 0 : paragraphs.map(function (paragraph) { return (_jsx(InlineBodyContent, { children: paragraph }, generateUUID())); })] })] }))) : (_jsxs(HeaderContainer, { children: [_jsx(ImageContainer, { children: _jsx(Image, { src: bannerImage, alt: altText }) }), _jsx(Title, { children: content }), (paragraphs === null || paragraphs === void 0 ? void 0 : paragraphs.length) > 0 && (_jsx(Inset, __assign({ all: "base" }, { children: paragraphs.map(function (paragraph, index) { return (_jsx(BodyContent, __assign({ "data-cy": "body-content-".concat(index) }, { children: paragraph }), generateUUID())); }) })))] }));
};
export default BannerWithText;
//# sourceMappingURL=index.js.map